<template>
    <div class="form-item">
        <div class="form-item__label">微信号：</div>
        <div class="form-item__body">
            <input v-model="info.contact"
            placeholder="填写微信号"
            class="form-item__body_input"/>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['info']
    }
</script>
